<div class="container">
  <div class="right">
    <p class="titleRight">Consultation sur rendez-vous</p>
    <div class="details">
      <p class="telephone">tél. 085 84 51 28</p>
      <p class="infoTel">Secrétariat ouvert tous les jours de 8h à 18h</p>
      <div class="divBarre"></div>
      <p class="telephone">tél. 0497 06 26 06</p>
      <p class="infoTel">Le lundi, le Docteur répond à vos appels</p>
    </div>
  </div>
  <div class="left">
    <table class="table">
      <tr>
        <th class="vide">&nbsp;</th>
        <th class="lun">Lundi</th>
        <th class="mar">Mardi</th>
        <th class="mer">Mercredi</th>
        <th class="jeu">Jeudi</th>
        <th class="ven">Vendredi</th>
      </tr>
      <tr>
        <td class="thLeft">Lieux</td>
        <td class="cabHuy">CHR Huy</td>
        <td class="cabHuy">CHR Huy</td>
        <td class="cabAnd">Cabinet privé Andenne</td>
        <td class="cabAnd">Cabinet privé Andenne</td>
        <td class="cabAnd">Cabinet privé Andenne</td>
      </tr>
      <tr>
        <td class="thLeft">Horaire</td>
        <td class="cabHuy time">8:30-13:00</td>
        <td class="cabHuy time">8:00-18:00</td>
        <td class="cabAnd time">8:00-16:00</td>
        <td class="cabAnd time">8:00-12:30</td>
        <td class="cabAnd time">8:00-13:00</td>
      </tr>
    </table>

    <table class="tableGSM">
      <tr>
        <th class="vide">&nbsp;</th>
        <th class="topTable">Lieux</th>
        <th class="topTable">Horaire</th>
      </tr>
      <tr>
        <td class="thLeft">Lundi</td>
        <td class="cabHuy">Cabinet médical Huy</td>
        <td class="cabHuy time">8:30-18:00</td>
      </tr>
      <tr>
        <td class="thLeft">Mardi</td>
        <td class="chr">CHR Huy</td>
        <td class="chr time">8:00-18:00</td>
      </tr>
      <tr>
        <td class="thLeft">Mercredi</td>
        <td class="cabAnd">Cabinet privé Andenne</td>
        <td class="cabAnd time">8:00-12:30</td>
      </tr>
      <tr>
        <td class="thLeft">Jeudi</td>
        <td class="cabAnd">Cabinet privé Andenne</td>
        <td class="cabAnd time">8:00-12:30</td>
      </tr>
      <tr>
        <td class="thLeft">Vendredi</td>
        <td class="chr">CHR Huy</td>
        <td class="chr time">8:00-18:00</td>
      </tr>
    </table>
  </div>
</div>
<footer>
  <div class="footbar"></div>
</footer>
